import { render, staticRenderFns } from "./alert-edit.vue?vue&type=template&id=0ccab2fd&"
import script from "./alert-edit.vue?vue&type=script&lang=js&"
export * from "./alert-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports